import React, { useCallback, useEffect, useRef, useState } from 'react'
import { styled } from '@mui/material/styles'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion'
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import { Box, Checkbox, Skeleton } from '@mui/material'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import _, { cloneDeep } from 'lodash'
import Image from '@components/Image'
import { colorSelection } from '@utils/colorSelection'
import { CustomizedSwitch } from '@components/customized/switch'
import { VariableSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';



const Accordion = styled((props: AccordionProps) => (
	<MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
	border: `1px solid ${theme.palette.divider}`,
	'&:not(:last-child)': {
		borderBottom: 0,
	},
	'&:before': {
		display: 'none',
	},
}))

const AccordionSummary = styled((props: AccordionSummaryProps) => (
	<MuiAccordionSummary
		expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
		{...props}
	/>
))(({ theme }) => ({
	backgroundColor:
		theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, .05)' : 'rgba(0, 0, 0, .03)',
	flexDirection: 'row-reverse',
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
		transform: 'rotate(90deg)',
	},
	'& .MuiAccordionSummary-content': {
		marginLeft: theme.spacing(1),
	},
}))

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(2),
	borderTop: '1px solid rgba(0, 0, 0, .125)',
}))

export default function CustomizedAccordions({
	list,
	selectedUsers,
	setSelectedUsers,
}: any) {
	const [expanded, setExpanded] = React.useState<number>(0)

	const handleChange = (panel: number) => (event: React.SyntheticEvent, newExpanded: boolean) => {
		setExpanded(newExpanded ? panel : 0)
	}

	const projectAccess = (productAccess:any) => {
		return <Box sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', height: '100%'}}>
				{productAccess?.map((sub: any)=>{
					return <Image
							src={sub.icon_url}
							width={24}
							height={24}
							themeColor={sub.isActive ? 
								colorSelection(sub?.productCode) 
								: 
								sub.enable ? colorSelection('disabled') : colorSelection('info')
							}
						/>
				})}
		</Box>
	}

	const [openElemlist, setOpenElemlist] = useState<number[]>([])

	const hadnleOpen = (itemIndex:number) => {
		if(openElemlist.includes(itemIndex)){
			let newOpenElemlist = [...openElemlist]
			const _index = openElemlist.indexOf(itemIndex)
			if(_index > -1){
				newOpenElemlist.splice(_index, 1)
			} 
			setOpenElemlist(newOpenElemlist)
			listRef.current.resetAfterIndex(itemIndex, true)
		}else{
			setOpenElemlist([...openElemlist, itemIndex])
			listRef.current.resetAfterIndex(itemIndex, true)
		}
	}

	const getItemSize = (index:number) => {
		if(openElemlist.includes(index) && list){
			return 44 + list[index]?.contents.length  * 71;
		}else{
			return 44;
		}
	}

	const listRef:any = useRef(null);

	const selectedUsersFromAddingUserTable = [...selectedUsers]

	const renderIsSelected = (userId: string) => {
		const isSelected = selectedUsersFromAddingUserTable?.find((x: string) => x === userId)
		return !!isSelected
	}
	const Row = ({ index, style }: any) => {
		const isOpen = openElemlist.includes(index);

		style={...style, display: 'flex', flexDirection: 'column', justifycontent: 'center',  alignItems: 'center' }
		return (<Box sx={style} key={list[index].title} onClick={()=>hadnleOpen(index)}>
			<Box sx={{backgroundColor:"#707070", height: '43px', color: '#FFFFFF', width: '100%', display: 'flex', justifyContent:'space-between', alignItems: 'center'}}>
				<Typography variant='h2' sx={{marginX: "40px", whiteSpace: 'noWrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{list[index].title}</Typography>
				{isOpen ? <KeyboardArrowUpIcon fontSize={"large"} sx={{marginX: '20px'}}/> : <KeyboardArrowDownIcon fontSize={"large"} sx={{marginX: '20px'}}/>}
			</Box>
			{isOpen && <>
				{list[index].contents?.map((user:any, i:number)=>{
					return <Box onClick={(e)=>e.stopPropagation()} key={i} sx={{border: '0.3px solid lightgrey', display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center', height: '72px', width: '100%', paddingX: '40px' }}>
						<Box sx={{ gridRow: '1', width: '160px', height: '20px', whiteSpace: 'noWrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{user.first_name + " " + user.last_name}</Box>
						<Box sx={{ gridRow: '1', width: '210px', height: '20px', whiteSpace: 'noWrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{user.company}</Box>
						<Box sx={{ gridRow: '1', width: '140px', height: '20px', whiteSpace: 'noWrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{user.position}</Box>
						<Box sx={{ gridRow: '1', width: '250px', height: '20px', whiteSpace: 'noWrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{user.email}</Box>
						<Box sx={{ gridRow: '1', }}>
						<CustomizedSwitch
							size='small'
							checked={ renderIsSelected(user.id) }
							onChange={ (_, checked) => {
								if(checked){
									setSelectedUsers([...selectedUsers, user.id])
								}else{
									let _index = [...selectedUsers].indexOf(user.id)
									if(_index !== -1){
										let _selectedUsers = [...selectedUsers]
										_selectedUsers.splice(_index, 1)
										setSelectedUsers(_selectedUsers)
									} 
								}
							} }
						/>
					</Box>
					</Box>
				})}
			</>}
		</Box>)

	};

	return (
		<Box sx={{height: '513px'}}>
			{list ? 
				<AutoSizer>
					{({ height, width }:any) => (
						<List
							height={height}
							width={width}
							itemCount={list?.length}
							itemSize={getItemSize}
							ref={listRef}
							key={list.length}
						>
							{Row}
						</List>
					)}
				</AutoSizer>
				:
				[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(()=>{
					return <Skeleton variant="rectangular" width={"100%"} height={44} sx={{marginY: "1px"}}/>
				})
			}
		</Box>
	)
}
